<template>
  <div class="pagination">
    <li><b-icon icon="chevron-left" @click="fn_prev_paging_view"></b-icon></li>
    <li v-for="(item, index) in pagination" :key="index" 
        :class="{ on:item == active}"
        @click="fn_move_paging(item)"
    >
        {{ item }}
    </li>
    <li><b-icon icon="chevron-right" @click="fn_next_paging_view"></b-icon></li>
  </div>
</template>

<script>
export default {
    name:'AdminPagination',
    props : ['pageInfo'],
    computed : {
        pagination : function() {
            
            let pagingCnt = Math.ceil(this.pageInfo.totPage / this.pageInfo.pageSize);
            let pagination = [];
            let pagingView = Math.floor((this.pageInfo.page-1) / 10);

            console.log("@@@@@ pagingCnt :"+pagingCnt);

            console.log("@@@@@ pagingView :"+pagingView);

            for(let i = pagingView*10 ; i < (pagingView+1)*10; i++){
                if( (i+1) * this.pageInfo.pageSize  < this.pageInfo.totPage){
                    pagination.push(i+1);
                }else if(pagingCnt > 0 && (i * this.pageInfo.pageSize) < this.pageInfo.totPage){
                    pagination.push(i+1);
                }
            }
            
            this.active = this.pageInfo.page;
            return pagination;
        }
    },
    data() {
        return {
            active: 1,
            //pagination:[1,2,3,4,5,6,7,8,9,10]
        }
    },
    methods : {
        fn_move_paging(page){
            this.active = page;
            this.$emit('clickPage',page);
        },
        fn_next_paging_view(){
            let pagingView = Math.floor((this.pageInfo.page-1) / 10);
            let nextPaging = ((pagingView+1)*10)+1;
            let pagingCnt = Math.ceil(this.pageInfo.totPage / this.pageInfo.pageSize);

            if(pagingCnt * this.pageInfo.pageSize >= nextPaging * this.pageInfo.pageSize){
                this.active = nextPaging;
                this.$emit('clickPage',nextPaging);
            }
        },
        fn_prev_paging_view(){
            let pagingView = Math.floor((this.pageInfo.page-1) / 10);
            
            if(pagingView > 0){
                let prevPaging = ((pagingView-1)*10)+1;
                this.active = prevPaging;
                this.$emit('clickPage',prevPaging);
            }
            
        }
    }
}
</script>

<style>

</style>